import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import type { Refinement } from '$/models/Refinement.d.ts';

const useCheckDnaSuggestions = () => {
  const client = supabaseClient;

  return useMutation({
    mutationFn: () => checkDnaSuggestions(client),
  });
};

export default useCheckDnaSuggestions;

async function checkDnaSuggestions(client: SupabaseClient): Promise<BackendSuccessResponse<Refinement | null>> {
  const { data, error } = await client.functions.invoke('check_dna_suggestions');

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }

  return data;
}
